
(function () {
  var ua = navigator.userAgent || '';
  // FB/IG in-app WebView detektálás (konzervatív token-készlet, false-pos kerülés).
  var isInApp = /FBAN|FB_IAB|FBIOS|FB4A|Instagram/i.test(ua);
  if (!isInApp) return; // sima Chrome/Safari/desktop → semmi.

  var isAndroid = /Android/i.test(ua);
  var isIOS = /iPhone|iPad|iPod/i.test(ua);

  function httpsTarget(box) {
    var host = box.getAttribute('data-host') || 'www.booksy.ro';
    var mode = box.getAttribute('data-mode');
    if (mode === 'precart') {
      // A termék URL-je: Liquidből (data-product-url), VAGY ha a snippet a layout-ból
      // jött (nincs `product` scope), akkor a jelenlegi PDP URL-jéből.
      var purl = box.getAttribute('data-product-url');
      if (!purl) { purl = window.location.pathname + window.location.search; }
      return 'https://' + host + purl;
    }
    var permalink = box.getAttribute('data-permalink') || '';
    return permalink ? ('https://' + host + '/cart/' + permalink) : ('https://' + host + '/cart');
  }

  function intentFor(httpsUrl) {
    // Android: az ALAPÉRTELMEZETT böngészőbe (nincs package= pin), https fallback-kel.
    var noScheme = httpsUrl.replace(/^https:\/\//, '');
    return 'intent://' + noScheme +
      '#Intent;scheme=https;S.browser_fallback_url=' + encodeURIComponent(httpsUrl) + ';end';
  }

  function wire(box) {
    if (box.getAttribute('data-wired')) return; // idempotens.
    box.setAttribute('data-wired', '1');

    var btn = box.querySelector('.js-booksy-inapp-btn');
    var copyBtn = box.querySelector('.js-booksy-inapp-copy');
    var copied = box.querySelector('.js-booksy-inapp-copied');
    var hint = box.querySelector('.js-booksy-inapp-hint');
    var urlEl = box.querySelector('.js-booksy-inapp-url');
    if (!btn) return;

    var httpsUrl = httpsTarget(box);

    if (isAndroid) {
      // Android: működő intent:// az alapértelmezett böngészőbe.
      btn.setAttribute('href', intentFor(httpsUrl));
      btn.textContent = 'Megnyitás böngészőben →';
      if (hint) { hint.hidden = false; } // tartalék útmutató azonnal.
    } else if (isIOS) {
      // iOS: x-safari HALOTT a modern webview-ban → copy-link + AZONNALI útmutató + kijelölhető URL.
      btn.setAttribute('href', 'https://' + httpsUrl.replace(/^https:\/\//, ''));
      btn.textContent = 'Megnyitás böngészőben →';
      btn.addEventListener('click', function (e) {
        // best-effort: új fül; ha a webview elnyeli, marad a copy + útmutató.
        try { window.open(httpsUrl, '_blank'); } catch (err) {}
      });
      if (copyBtn) {
        copyBtn.hidden = false;
        copyBtn.addEventListener('click', function () {
          var done = function () { if (copied) { copied.hidden = false; } };
          try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(httpsUrl).then(done, function () { if (urlEl) urlEl.hidden = false; });
            } else if (urlEl) { urlEl.hidden = false; }
          } catch (err) { if (urlEl) urlEl.hidden = false; }
        });
      }
      if (hint) { hint.hidden = false; }          // azonnali ••• útmutató (nem timeout után).
      if (urlEl) { urlEl.textContent = httpsUrl; urlEl.setAttribute('href', httpsUrl); urlEl.hidden = false; }
    } else {
      // egyéb in-app → sima https új fülben.
      btn.setAttribute('href', httpsUrl);
      btn.setAttribute('target', '_blank');
      btn.setAttribute('rel', 'noopener');
      btn.textContent = 'Megnyitás böngészőben →';
    }

    // PDP pre-cart: ha a snippet a layout-aljáról jött, a kártyát a valódi "Kosárba"
    // gomb fölé pozícionáljuk (a hajtás közelébe, nem az oldal aljára).
    if (box.getAttribute('data-mode') === 'precart' && !box.getAttribute('data-positioned')) {
      var atc = document.querySelector('.btn--add-to-cart') ||
                document.querySelector('[data-add-to-cart]') ||
                document.querySelector('button[name="add"]');
      if (atc) {
        var anchor = atc.closest('form, .product-form, .product-single__meta, .product__info') || atc;
        if (anchor && anchor.parentNode) {
          anchor.parentNode.insertBefore(box, anchor);
          box.setAttribute('data-positioned', '1');
        }
      }
    }

    box.hidden = false;
  }

  function init() {
    var boxes = document.querySelectorAll('.js-booksy-inapp');
    for (var i = 0; i < boxes.length; i++) { wire(boxes[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
